import { ReviewDispatcher as SourceReviewDispatcher } from 'SourceStore/Review/Review.dispatcher';
import ReviewQuery from 'Query/Review.query';
import { showNotification } from 'Store/Notification/Notification.action';
import { fetchMutation } from 'Util/Request';

export class ReviewDispatcher extends SourceReviewDispatcher {
    submitProductReview(dispatch, options) {
        const reviewItem = options;

        reviewItem.rating_data = this.prepareRatingData(reviewItem);

        return fetchMutation(ReviewQuery.getAddProductReviewMutation(
            reviewItem
        )).then(
            () => dispatch(showNotification('success', __('Thank you! Your review shall be visible on the website right after the validation.'))),
            // eslint-disable-next-line no-console
            error => dispatch(showNotification('error', __('Error submitting review!'))) && console.log(error)
        );
    }
}

export default new ReviewDispatcher();
